module.exports = __webpack_public_path__ + "static/media/card.783c2780.jpg";